import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ApiLoginService } from 'src/app/services/login/api-login.service';
import { LocalstorageService } from 'src/app/services/storage/localstorage.service';
import { AuthenticatorService } from 'src/app/services/authenticator/authenticator.service';
import { StyleHelpersService } from 'src/app/services/styleHelpers/style-helpers.service';
import { AmbienteSefazService } from 'src/app/services/ambiente-sefaz/ambiente-sefaz.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() usuarioLogado: any = {};
  @Input() usuarioAutenticado: boolean = false;

  atualizaUsuario:any = {
    usuario       : '',
    senhaAtual    : '',
    novaSenha     : '',
    confirmaSenha : '',
    dicaSenha     : '',
    param         : true
  }
  configXML:any = {
    ordenar_pendencias  : 'padrao',
    aba_padrao          : ''
  }

  ordenacao:any = '';

  empresaCount:boolean = false;
  visualizaSenha:boolean = false;
  visualizaNovaSenha:boolean = false;
  visualizaSenhaConfirm:boolean = false;
  
  chkOrdenaPendencias:any = {
    padrao      : true,
    nf          : false,
    sts         : false,
    dt_emss     : false,
    forn        : false,
    nf_dec      : false,
    sts_dec     : false,
    dt_emss_dec : false,
    forn_dec    : false
  }

  chkAbaPadrao:any = {
    pend_nfe        : true,
    pend_tms        : false,
    pend_cte        : false,
    pend_tipo_integ : false
  }

  trocaEmpresa:any = ''

  AlertSenha:any = {
    showAlert:true,
    senha: ''
  }

  ambiente:string = '';
  param_alert:string = '';
  duploFator: boolean = false;
  codeOTP: string = '';
  AuthKey:any = {};
  autorizado: boolean = false;
  alertAuth: boolean = false;

  constructor(
    private http: HttpClient,
    private apiLogin: ApiLoginService,
    private API: ApiService,
    private APIauth: AuthenticatorService,
    private Router: Router,
    private localStorage: LocalstorageService,
    private styleHelpers: StyleHelpersService,
    private ambienteSefaz: AmbienteSefazService
  ) { }


  ngOnInit(): void {
    this.getUsuarioStorage();
    this.getParam();
    // this.styleHelpers.getStyles();

  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.styleHelpers.getStyles();
    });
  }

  // ngOnDestroy(): void {
  //   // Importante para parar o loop quando sair da tela
  //   this.styleHelpers.stopLoop?.(); // só se você criou esse método
  // }

  ngOnChanges(){
    this.getUsuarioStorage();
    // this.param_alert = JSON.parse(this.localStorage.getData('PARAM_ALERT'))
  }

  getParam(){
    this.http.get("assets/config.json?" + Math.random()).subscribe(data => {
      let param = JSON.parse(JSON.stringify(data))
      if("textoToolbar" in param){
        this.ambiente = param.textoToolbar
      }
    })
  }

  testCodeOTP(){
    var login = JSON.parse(this.localStorage.getData('LOGIN'))
    this.APIauth.getFromApi("valida_otp", {...login, otp_code: this.codeOTP}, (Retorno:any) =>{
      this.autorizado = Retorno.authorization
      if(this.autorizado){
          document.getElementById("close_modal_autenticator")?.click()
      }
    },false,"");
  }

  modalPerfil(){
    this.duploFator = JSON.parse(this.localStorage.getData('TwoFactAuth'));
    var element: any = document.getElementById('ativarAutenticacaoSwitch')
    element.checked = this.duploFator
  }

  autenticacaoDoisFatores(){
    var usuario = JSON.parse(this.localStorage.getData('USUARIO'))
    this.duploFator = !this.duploFator;
    var element: any = document.getElementById('ativarAutenticacaoSwitch')
    element.checked = this.duploFator
    if(this.duploFator){
      this.APIauth.getFromApi('cadastro',{usuario:usuario.usuario},(Retorno:any)=>{
        this.AuthKey = Retorno
        this.AuthKey.qrcode = 'data:image/png;base64,'+this.AuthKey.qrcode
        this.API.getFromApi('Functions','updateDuploFator',{id_nfer_usuario:usuario.cod_usuario, duplo_fator: this.duploFator},(Retorno:any)=>{
              if(Retorno.mostraRetorno){
                console.log("RETORNO API =", Retorno);
              }
              this.localStorage.setData('TwoFactAuth',this.duploFator)
              document.getElementById('modalQRcode_button')?.click()
            },true,"");
        }, false,"");
    }else{
      document.getElementById('modalCancelaAutenticador_button')?.click()
      this.AuthKey = {}
      this.alertAuth = false;
      this.autorizado = false
      this.codeOTP = ""
    }
  }

  cancelaAutenticador(){
    
    var usuario = JSON.parse(this.localStorage.getData('USUARIO'))
    var element: any = document.getElementById('ativarAutenticacaoSwitch')
    element.checked = this.duploFator
    var login = JSON.parse(this.localStorage.getData('LOGIN'))
    this.APIauth.getFromApi("valida_otp", {...login, otp_code: this.codeOTP}, (Retorno:any) =>{
      this.autorizado = Retorno.authorization
      if(this.autorizado){
        this.API.getFromApi('Functions','updateDuploFator',{id_nfer_usuario:usuario.cod_usuario, duplo_fator: this.duploFator},(Retorno:any)=>{
            if(Retorno.mostraRetorno){
              console.log("RETORNO API =", Retorno);
            }
            this.localStorage.setData('TwoFactAuth',this.duploFator)
              document.getElementById("close_cancela_autenticator")?.click()
          },true,"");
      }
    },false,"");
  }

  limpaModalsAuth(modal:any){
    if(modal == 1){
      if(this.autorizado){
        document.getElementById("close_modal_autenticator")?.click()
        this.AuthKey = {}
        this.alertAuth = false;
        this.autorizado = false
        this.codeOTP = ""
      }else{
        
        this.duploFator = false;
        var usuario = JSON.parse(this.localStorage.getData('USUARIO'))
        var element: any = document.getElementById('ativarAutenticacaoSwitch')
        element.checked = this.duploFator
        this.API.getFromApi('Functions','updateDuploFator',{id_nfer_usuario:usuario.cod_usuario, duplo_fator: this.duploFator},(Retorno:any)=>{
          if(Retorno.mostraRetorno){
            console.log("RETORNO API =", Retorno);
          }
          this.localStorage.setData('TwoFactAuth',this.duploFator)
          document.getElementById("close_modal_autenticator")
        },true,"");
      }
    }else{
      this.AuthKey = {}
      this.alertAuth = false;
      this.autorizado = false
      this.codeOTP = ""
    }
  }
  
  // changeAnimationAlert(){

  //   const sino:any = document.getElementById('sino');
  
  //   const animations = [
  //     'balancarSino 2s ease-in-out infinite', // Animação de balanço
  //     'pulsarSino 1.5s ease-in-out infinite', // Animação de pulsar
  //   ];
  //   var currentAnimation = 0;
  //   currentAnimation = (currentAnimation + 1) % animations.length;

  //   sino.style.animation = animations[currentAnimation];
  //   setInterval(this.changeAnimationAlert(), 2000);
  // }

  getUsuarioStorage(){
    const _self = this;
    this.apiLogin.getUsuarioStorage()
      .then(usuarioStorage => {
        if (usuarioStorage != undefined) {
          _self.usuarioLogado = usuarioStorage;
          if(_self.usuarioLogado.empresas.length == 1){
            _self.empresaCount = true
          }else{
            _self.empresaCount = false
          }
        }
      })
      .catch(erro => {
        console.warn('app.component.ts - erro ao buscar usuario no datastorage: ', erro)
      })
  }

  getConfig(){
    const _self = this;
    _self.API.getFromApi('Config','Select',{},(Retorno:any) => {
      _self.configXML = Retorno.config
      _self.localStorage.setData('CONFIG',_self.configXML)
    },false,"");

  }

  atualizarPerfil(){
    const _self = this;
    _self.atualizaUsuario.usuario = _self.usuarioLogado.usuario;
    if(_self.atualizaUsuario.novaSenha == _self.atualizaUsuario.confirmaSenha && _self.AlertSenha.showAlert){
      let user:any = {..._self.atualizaUsuario}
       user.senhaAtual = CryptoJS.MD5(_self.atualizaUsuario.senhaAtual).toString()
       user.novaSenha = CryptoJS.MD5(_self.atualizaUsuario.novaSenha).toString()
      _self.API.getFromApi('Usuarios', 'AtualizaLogin', user, (Retorno:any) => {
        if(Retorno.mostraRetorno){
          console.log("RETORNO API =", Retorno);
        }
        document.getElementById('close-modalPerfil')?.click()
        setTimeout( () =>{
          _self.logout()
        }, 500)
      }, true, "");
    }
  }
  
  trocarEmpresa(){
    
    const _self = this;
    if(_self.trocaEmpresa != ''){
      for(let i = 0; i < _self.usuarioLogado.empresas.length; i++){
        if(_self.usuarioLogado.empresas[i].id_nfer_empresa == _self.trocaEmpresa){
          _self.usuarioLogado.cod_empresa = _self.usuarioLogado.empresas[i].cod_empresa
          _self.usuarioLogado.empresa_nome = _self.usuarioLogado.empresas[i].den_empresa
          _self.usuarioLogado.empresa_id = _self.trocaEmpresa
          _self.usuarioLogado.cod_estab = _self.usuarioLogado.empresas[i].cod_estab
          break;
        }
      }
      var obj = {
        cod_empresa: _self.usuarioLogado.cod_empresa,
        den_empresa: _self.usuarioLogado.empresa_nome,
        id_nfer_empresa_k: _self.usuarioLogado.empresa_id,
        cod_estab: _self.usuarioLogado.cod_estab
      }
      _self.API.getFromApi('Functions', 'trocaEmpresa', obj, (Retorno:any) => {
        if(Retorno.mostraRetorno){
          console.log("RETORNO API =", Retorno);
        }
        
        if(Retorno.status){
          this.localStorage.removeData('USUARIO')
          this.localStorage.setData('USUARIO', _self.usuarioLogado);
          var login = {
            cod_empresa:  _self.usuarioLogado.cod_empresa,
            cod_usuario:  _self.usuarioLogado.cod_usuario,
            empresa_id:  _self.usuarioLogado.empresa_id,
            manter:  _self.usuarioLogado.manter,
            senha:  _self.usuarioLogado.senha,
            usuario:  _self.usuarioLogado.usuario,
            usuarioAutenticado:  _self.usuarioLogado.usuarioAutenticado
          }
          this.localStorage.setData('LOGIN',login);
          var permissoesUsuario = JSON.parse(this.localStorage.getData('PERMISSOES'))
          var permissoes = {
            administrador: permissoesUsuario.administrador,
            cod_empresa: _self.usuarioLogado.cod_empresa,
            cod_estab: _self.usuarioLogado.cod_estab,
            cod_usuario: _self.usuarioLogado.cod_usuario,
            den_empresa: _self.usuarioLogado.empresa_nome,
            email_usuario: permissoesUsuario.email_usuario,
            id_nfer_empresa_k: _self.usuarioLogado.empresa_id,
            licenca: permissoesUsuario.licenca,
            login: _self.usuarioLogado.usuario,
            manter: _self.usuarioLogado.manter,
            nom_usuario: permissoesUsuario.nom_usuario,
            parametro_alert: permissoesUsuario.parametro_alert,
            permissoes:permissoesUsuario.permissoes,
            scalar:permissoesUsuario.scalar
          }
          this.localStorage.setData('PERMISSOES',permissoes);

          _self.API.getFromApi('Functions', 'atualizaAmbienteSefaz', {}, (Retorno:any) => {
            _self.ambienteSefaz.setStatus(Retorno.sefaz_prod_homolog)
          }, false, "")
        }
        // _self.getUsuarioStorage()
        location.reload()
      }, false, "");
    }
  }

  carregaChkConfig(){
    const _self = this;
  
    var modal:any = document.getElementById('modalConfig')
    _self.configXML = JSON.parse(_self.localStorage.getData('CONFIG'))
    modal.addEventListener('shown.bs.modal', function () {
      var chk_ord:any = document.getElementById('ord_pend_'+_self.configXML.ordenar_pendencias)
      if(!chk_ord.checked){
        document.getElementById('ord_pend_'+_self.configXML.ordenar_pendencias)?.click()
      }
      
      var chk_aba:any = document.getElementById('aba_pad_'+_self.configXML.aba_padrao)
      if(_self.configXML.aba_padrao != '' && !chk_aba.checked){
        document.getElementById('aba_pad_'+_self.configXML.aba_padrao)?.click()
      }
    }, {once: true});
  }

  selecionaOrdenacaoPendencia(selecionado:string){
    const _self = this;
    _self.chkOrdenaPendencias = {
      padrao      : false,
      nf          : false,
      sts         : false,
      dt_emss     : false,
      forn        : false,
      nf_dec      : false,
      sts_dec     : false,
      dt_emss_dec : false,
      forn_dec    : false
    }

    _self.configXML.ordenar_pendencias = selecionado

    switch(selecionado){
      case'padrao':
      _self.chkOrdenaPendencias.padrao = true;
      _self.ordenacao = 'padrao';
      break;
      case'nf':
      _self.chkOrdenaPendencias.nf = true;
      _self.ordenacao = 'nf';
      break;
      case'sts':
      _self.chkOrdenaPendencias.sts = true;
      _self.ordenacao = 'sts';
      break;
      case'dt_emss':
      _self.chkOrdenaPendencias.dt_emss = true;
      _self.ordenacao = 'dt_emss';
      break;
      case'forn':
      _self.chkOrdenaPendencias.forn = true;
      _self.ordenacao = 'forn';
      break;
      case'nf_dec':
      _self.chkOrdenaPendencias.nf_dec = true;
      _self.ordenacao = 'nf_dec';
      break;
      case'sts_dec':
      _self.chkOrdenaPendencias.sts_dec = true;
      _self.ordenacao = 'sts_dec';
      break;
      case'dt_emss_dec':
      _self.chkOrdenaPendencias.dt_emss_dec = true;
      _self.ordenacao = 'dt_emss_dec';
      break;
      case'forn_dec':
      _self.chkOrdenaPendencias.forn_dec = true;
      _self.ordenacao = 'forn_dec';
      break;
    }
  }

  selecionaAbaPadrao(selecionado:string){
    const _self = this;

    _self.chkAbaPadrao =  {
      pend_nfe        : false,
      pend_tms        : false,
      pend_cte        : false,
      pend_tipo_integ : false
    }

    _self.configXML.aba_padrao = selecionado

    switch(selecionado){
      case'pend_nfe':
    _self.chkAbaPadrao.pend_nfe = true      
      break;
      case'pend_tms':
        _self.chkAbaPadrao.pend_tms = true
      break;
      case'pend_cte':
        _self.chkAbaPadrao.pend_cte = true
      break;
      case'pend_tipo_integ':
        _self.chkAbaPadrao.pend_tipo_integ = true
      break;
    }
  }

  salvarConfig(){
    const _self = this;
    _self.localStorage.setData('CONFIG',_self.configXML)
    _self.usuarioLogado;
    var obj = {
      chkOrdenaPendencias: _self.chkOrdenaPendencias,
      chkAbaPadrao: _self.chkAbaPadrao,
      id_nfer_usuario: '',
      ordenacao: '',
      aba_padrao: ''
    }
    _self.API.getFromApi('Functions','configUsuarios',obj,(Retorno:any) => {
      if(Retorno.mostraRetorno){
        console.log("RETORNO API =", Retorno);
      }
    },true,"");
  }

  limpaForm(){
    const _self = this;
    _self.atualizaUsuario = {
      usuario:'',
      novaSenha:'',
      confirmaSenha:'',
    }
    _self.chkOrdenaPendencias = {
      padrao      : false,
      nf          : false,
      sts         : false,
      dt_emss     : false,
      forn        : false,
      nf_dec      : false,
      sts_dec     : false,
      dt_emss_dec : false,
      forn_dec    : false
    }

    _self.AlertSenha = {
      showAlert:true,
      senha: ''
    }

  }

  verificaSenha(){
    const _self = this;
    var regNumero = /(?=.*\d)/;
    var regLetra = /(?=.*[a-z])/;
    var regLetraCaps = /(?=.*[A-Z])/;
    var regCaracEs = /(?=.*[^\w\s])/
    
    _self.AlertSenha.senha = ''
    if(this.atualizaUsuario.novaSenha.length < 6){
      _self.AlertSenha.senha = "A senha deve conter pelo menos 6 caracteres";
    }
    if(!regNumero.test(this.atualizaUsuario.novaSenha)){
      if(_self.AlertSenha.senha.length == 0){
        _self.AlertSenha.senha = "A senha deve conter pelo menos 1 número";
      }else{
        _self.AlertSenha.senha += "\n A senha deve conter pelo menos 1 número";
      }
    }
    if(!regLetra.test(this.atualizaUsuario.novaSenha)){
      if(_self.AlertSenha.senha.length == 0){
        _self.AlertSenha.senha = " A senha deve conter pelo menos 1 letra minuscula";
      }else{
        _self.AlertSenha.senha += "\n A senha deve conter pelo menos 1 letra minuscula";
      }
    }
    if(!regLetraCaps.test(this.atualizaUsuario.novaSenha)){
      if(_self.AlertSenha.senha.length == 0){
        _self.AlertSenha.senha = " A senha deve conter pelo menos 1 letra maiuscula";
      }else{
        _self.AlertSenha.senha += "\n A senha deve conter pelo menos 1 letra maiuscula";
      }
    }
    if(!regCaracEs.test(this.atualizaUsuario.novaSenha)){
      if(_self.AlertSenha.senha.length == 0){
        _self.AlertSenha.senha = " A senha deve conter pelo menos 1 caracter especial como: !@#$&";
      }else{
        _self.AlertSenha.senha += "\n A senha deve conter pelo menos 1 caracter especial como: !@#$&";
      }
    }
    if(_self.AlertSenha.senha.length > 0){
      _self.AlertSenha.showAlert = false;
    }else{
      _self.AlertSenha.showAlert = true;
    }
  }

  visualizarSenha(input:string){
    const _self = this;
 
    let element:any = document.getElementById(input)

      switch(input){
        case'senha_atual':
        _self.visualizaSenha = !_self.visualizaSenha
          if(_self.visualizaSenha){
            element.type = 'text'
          }else{
            element.type = 'password'
          }
        break;
        case'nova_senha':
        _self.visualizaNovaSenha = !_self.visualizaNovaSenha
          if(_self.visualizaNovaSenha){
            element.type = 'text'
          }else{
            element.type = 'password'
          }
        break;

        case'confirm_senha':
        _self.visualizaSenhaConfirm = !_self.visualizaSenhaConfirm
          if(_self.visualizaSenhaConfirm){
            element.type = 'text'
          }else{
            element.type = 'password'
          }
        break;
      }
  }

  collapseMenu(){
    let sidebar_classList = document.getElementById('sidebar-menu');
    let menus = document.getElementsByClassName('btn-menus');

    if (sidebar_classList?.classList.contains('hide')) {
      sidebar_classList.classList.remove('hide');
      sidebar_classList.classList.add('open');
    } else {
      sidebar_classList?.classList.remove('open');
      sidebar_classList?.classList.add('hide');
      for (let i = 0; i < menus.length; i++) {
        if (!menus[i].classList.contains('collapsed')) {
          let element: HTMLElement = menus[i] as HTMLElement;
          element.click();
        };
      }
    }
  }

  logout(){
    for(let i = 0; i < this.apiLogin.listaSubMenus.length; i++){
      this.apiLogin.listaSubMenus[i].hidden = false
    }
    this.apiLogin.logout();
  }

}
